import sendMetricToNoflake from '~src/lib/api/noflake';

export default function({ eventType, user, path, pageTitle, target, beacon }) {
  if (eventType === 'pageView') {
    sendMetricToNoflake(
      user,
      path,
      { method: 'page_view' },
      { status: 200 },
      {},
      pageTitle,
    );
  }

  if (eventType === 'click') {
    sendMetricToNoflake(
      user,
      path,
      { method: 'click', body: { target, beacon } },
      { status: 200 },
      {},
      pageTitle,
    );
  }
}
